import React from "react";
import { Card } from "@yleisradio/areena-types";
import { darkTheme } from "@yleisradio/yds-core";
import { Close } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import i18n from "../../service/i18n";
import { buttonStyle } from "../../styles/global";
import { focusColor } from "../../styles/variables";
import { RecommendationCard } from "../recommendations/RecommendationCard";
import { RecommendationList } from "../recommendations/RecommendationStyles";
import { CommonCardProps } from "../recommendations/recommendationTypes";

const PauseRecommendationsBackground = styled.div<{ newPlayerUi: boolean }>`
  background: rgb(0 0 0 / 60%);
  left: 10px;
  padding: 20px;
  position: absolute;
  right: 10px;
  top: ${props => (props.newPlayerUi ? "56px" : "10px")};
  z-index: 20;
`;

const PauseRecommendationClose = styled.button`
  background: transparent;
  color: ${darkTheme.ACTION_PRIMARY};
  display: block;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  ${buttonStyle}

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

export const PauseRecommendations = ({
  commonCardProps,
  disabled,
  onClickRecommendation,
  onClickRecommendationPlay,
  onClose,
  onViewRecommendation,
  recommendations,
  showRecommendations
}: {
  commonCardProps: CommonCardProps;
  disabled: boolean;
  onClose: () => void;
  recommendations: Card[];
  showRecommendations: boolean;
  onViewRecommendation: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
  onClickRecommendation: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
  onClickRecommendationPlay: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
}) =>
  showRecommendations ? (
    <PauseRecommendationsBackground newPlayerUi={commonCardProps.newPlayerUi}>
      <PauseRecommendationClose
        aria-label={i18n("sulje_suosittelulistaus", {
          language: commonCardProps.language
        })}
        disabled={disabled}
        onClick={onClose}>
        <Close />
      </PauseRecommendationClose>
      <RecommendationList>
        {recommendations.map((recommendation, index) => (
          <RecommendationCard
            key={`pause-recommendation-${index}`}
            onView={viewUuid =>
              onViewRecommendation(recommendation, index, viewUuid)
            }
            onClick={viewUuid =>
              onClickRecommendation(recommendation, index, viewUuid)
            }
            onClickPlay={viewUuid =>
              onClickRecommendationPlay(recommendation, index, viewUuid)
            }
            {...{
              ...commonCardProps,
              disabled,
              index,
              recommendation
            }}
          />
        ))}
      </RecommendationList>
    </PauseRecommendationsBackground>
  ) : null;
